import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

export interface ICommissionExcelReportSubmit {
    mgrNo?: number;
    begPeriod: number;
    endPeriod: number;
}

interface ICommissionExcelReportDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onSubmit: (params: ICommissionExcelReportSubmit) => void;
    defaultPeriodNo?: number;
}

const labelStyle: React.CSSProperties = { whiteSpace: 'nowrap', width: '9rem' };
const fieldStyle: React.CSSProperties = { width: '100%' };

// Mirrors the plain "Excel" window (oid 565, XL_PM_Margin) - the common-case path the "Excel Report"
// toolbar button routes to. Filename is dropped since the browser's own download replaces Oracle's
// local file-save dialog. The other toolbar-routed window, "Excel_AMPM" (a different field set -
// Actual/Est, Bonus Status, no period range - reached when mod(period_no, 100) is 4/10/16/22), is
// not covered here.
const CommissionExcelReportDialog = (props: ICommissionExcelReportDialogProps) => {
    const { register, errors, getValues } = useForm();

    const handleOk = () => {
        const values = getValues();
        if (!values.begPeriod || !values.endPeriod) {
            return;
        }
        props.onSubmit({
            mgrNo: values.mgrNo ? Number(values.mgrNo) : undefined,
            begPeriod: Number(values.begPeriod),
            endPeriod: Number(values.endPeriod),
        });
    };

    return (
        <Dialog title="Excel Report" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '26%' }}>
            <form>
                <RHFInputBox
                    label="Mgr. No."
                    labelOnLeft={true}
                    labelStyle={labelStyle}
                    name="mgrNo"
                    type="number"
                    register={register}
                    errors={errors}
                    style={fieldStyle}
                    title="Blank = All Managers"
                />
                <div style={{ marginTop: '.75rem' }}>
                    <RHFInputBox
                        label="Beg. Period"
                        labelOnLeft={true}
                        labelStyle={labelStyle}
                        name="begPeriod"
                        type="number"
                        register={register}
                        errors={errors}
                        style={fieldStyle}
                        defaultVal={props.defaultPeriodNo !== undefined ? String(props.defaultPeriodNo) : undefined}
                    />
                </div>
                <div style={{ marginTop: '.75rem' }}>
                    <RHFInputBox
                        label="End Period"
                        labelOnLeft={true}
                        labelStyle={labelStyle}
                        name="endPeriod"
                        type="number"
                        register={register}
                        errors={errors}
                        style={fieldStyle}
                        defaultVal={props.defaultPeriodNo !== undefined ? String(props.defaultPeriodNo) : undefined}
                    />
                </div>
            </form>
            <div className="form-row" style={{ marginTop: '1.5rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '25%', marginRight: '1rem' }} text="OK" onClick={handleOk} />
                <Button className="blue-hover-button" style={{ width: '25%' }} text="Cancel" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default CommissionExcelReportDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/CommissionExcelReportDialog.tsx